import { isAxiosError } from 'axios';

/** Lê o JSON de uma resposta binária antes de normalizar o erro (U02). */
export async function parseBlobError(error: unknown): Promise<void> {
  if (!isAxiosError(error) || !(error.response?.data instanceof Blob)) return;
  try {
    const parsed: unknown = JSON.parse(await error.response.data.text());
    error.response.data = parsed;
  } catch {
    // Gateway pode retornar HTML ou binário: conserva o erro original.
  }
}
